package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.UbisoftSimpleIcons: ImageVector
    get() {
        if (_ubisoftSimpleIcons != null) {
            return _ubisoftSimpleIcons!!
        }
        _ubisoftSimpleIcons = Builder(name = "UbisoftSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(23.56f, 11.99f)
                curveTo(23.30f, -0.30f, 6.95f, -4.89f, 0.66f, 6.63f)
                curveToRelative(0.28f, 0.21f, 0.66f, 0.48f, 0.94f, 0.67f)
                arcToRelative(11.75f, 11.75f, 0.0f, false, false, -0.98f, 3.07f)
                arcToRelative(11.89f, 11.89f, 0.0f, false, false, -0.18f, 2.07f)
                curveTo(0.44f, 18.82f, 5.62f, 24.0f, 12.01f, 24.0f)
                curveToRelative(6.39f, 0.0f, 11.56f, -5.17f, 11.56f, -11.56f)
                verticalLineToRelative(-0.46f)
                close()
                moveTo(3.29f, 14.05f)
                curveToRelative(-0.15f, 1.25f, -0.05f, 1.64f, -0.05f, 1.79f)
                lineToRelative(-0.28f, 0.10f)
                curveToRelative(-0.11f, -0.21f, -0.37f, -0.93f, -0.49f, -1.91f)
                curveTo(2.16f, 10.31f, 4.7f, 6.96f, 8.57f, 6.33f)
                curveToRelative(3.54f, -0.52f, 6.94f, 1.68f, 7.73f, 4.76f)
                lineToRelative(-0.28f, 0.10f)
                curveToRelative(-0.09f, -0.09f, -0.23f, -0.34f, -0.77f, -0.88f)
                curveToRelative(-4.28f, -4.28f, -11.00f, -2.32f, -11.96f, 3.74f)
                close()
                moveTo(14.29f, 16.13f)
                arcToRelative(3.15f, 3.15f, 0.0f, false, true, -2.59f, 1.36f)
                arcToRelative(3.15f, 3.15f, 0.0f, false, true, -3.16f, -3.16f)
                arcToRelative(3.16f, 3.16f, 0.0f, false, true, 2.93f, -3.14f)
                curveToRelative(1.02f, -0.04f, 1.97f, 0.51f, 2.42f, 1.40f)
                arcToRelative(2.58f, 2.58f, 0.0f, false, true, -0.46f, 2.95f)
                curveToRelative(0.29f, 0.21f, 0.58f, 0.4f, 0.86f, 0.60f)
                close()
                moveTo(20.87f, 16.25f)
                curveToRelative(-1.67f, 3.78f, -5.11f, 5.77f, -8.77f, 5.71f)
                curveToRelative(-7.03f, -0.35f, -9.08f, -8.47f, -4.38f, -11.39f)
                lineToRelative(0.21f, 0.21f)
                curveToRelative(-0.08f, 0.11f, -0.36f, 0.33f, -0.79f, 1.18f)
                curveToRelative(-0.51f, 1.04f, -0.67f, 2.08f, -0.61f, 2.73f)
                curveToRelative(0.37f, 5.67f, 8.31f, 6.83f, 11.05f, 1.21f)
                curveTo(21.06f, 8.22f, 11.82f, 0.40f, 3.63f, 6.37f)
                lineToRelative(-0.18f, -0.18f)
                curveTo(5.60f, 2.81f, 9.82f, 1.3f, 13.84f, 2.31f)
                curveToRelative(6.15f, 1.55f, 9.45f, 7.96f, 7.04f, 13.94f)
                close()
            }
        }
        .build()
        return _ubisoftSimpleIcons!!
    }

private var _ubisoftSimpleIcons: ImageVector? = null
